// Injection key
export const CustomLoggerProvider = Symbol();
